import { SVGProps } from "react";

export function MessagesIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={48} cy={36} r={24} fill="#DEDFE0" opacity={0.2} />
      <path
        fill="#AACFD3"
        d="M14.56 52.44c-.944.944-2.56.275-2.56-1.061V22.723c0-.724.268-1.358.804-1.904.536-.546 1.176-.819 1.92-.819h30.424c.724 0 1.359.273 1.905.819.546.546.818 1.18.818 1.904v22.873c0 .724-.273 1.359-.818 1.905-.546.546-1.18.819-1.905.819H19.302a1.5 1.5 0 0 0-1.06.439l-3.681 3.68Z"
      />
      <rect
        width={27}
        height={3}
        x={17}
        y={26}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={27}
        height={3}
        x={17}
        y={31}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={27}
        height={3}
        x={17}
        y={36}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <path
        fill="#3E8D96"
        d="M65.454 68.52c.95.926 2.546.253 2.546-1.074V38.625c0-.67-.27-1.276-.809-1.816S66.023 36 65.304 36H34.75c-.689 0-1.31.27-1.865.81-.554.539-.831 1.144-.831 1.815v22.75c0 .67.277 1.276.831 1.816.554.54 1.176.809 1.865.809H60.2a1.5 1.5 0 0 1 1.047.425l4.206 4.096Z"
      />
      <path
        fill="#F7F8F8"
        d="m54.632 45.608-7.8 7.75-3.55-3.5a1.64 1.64 0 0 0-1.05-.425c-.4-.016-.75.125-1.05.425-.3.3-.45.65-.45 1.05s.15.75.45 1.05l4.6 4.6c.3.3.65.45 1.05.45s.75-.15 1.05-.45l8.85-8.85c.3-.3.45-.65.45-1.05s-.144-.75-.43-1.05c-.314-.3-.67-.45-1.07-.45s-.75.15-1.05.45Z"
      />
    </svg>
  );
}
